module.exports = __webpack_public_path__ + "static/media/29.c406b4b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/29.png
// module id = 811
// module chunks = 0